const jsLessons = [
  {
    title: "Hello World",
    code: `// Hello World in js
console.log("Hello, World!");`
  },
  {
    title: "Variables and Data Types",
    code: `// Variables and Data Types
// Using let (can be reassigned)
let age = 25;

// Using const (cannot be reassigned)
const name = "Rajan";

// Using var (function-scoped, older way)
var city = "Delhi";

// Different data types
let isStudent = true;          // Boolean
let score = 95.5;              // Number
let fruits = ["apple", "banana"]; // Array
let person = {                 // Object
  name: "Rajan",
  age: 25
};

// Null and Undefined
let emptyValue = null;
let notAssigned;

console.log("Name:", name);
console.log("Age:", age);
console.log("Is Student:", isStudent);
console.log("Fruits:", fruits);
console.log("Person:", person);
console.log("Empty:", emptyValue);
console.log("Not assigned:", notAssigned);`
  },
  {
    title: "Arithmetic Operations",
    code: `// Arithmetic operations
let a = 15;
let b = 4;

console.log("a =", a, "b =", b);
console.log("Addition:", a + b);
console.log("Subtraction:", a - b);
console.log("Multiplication:", a * b);
console.log("Division:", a / b);
console.log("Modulus:", a % b);
console.log("Exponent:", a ** b);

// Increment and decrement
let count = 10;
count++; // post-increment
console.log("After increment:", count);

count--; // post-decrement
console.log("After decrement:", count);

// Compound assignment
let x = 10;
x += 5; // x = x + 5
console.log("x after += 5:", x);

x *= 2; // x = x * 2
console.log("x after *= 2:", x);`
  },
  {
    title: "String Operations",
    code: `// String operations
let firstName = "Rajan";
let lastName = "Kumar";

// Concatenation
let fullName = firstName + " " + lastName;
console.log("Full Name:", fullName);

// Template literals (ES6)
let message = \`Hello \${firstName}, welcome to JavaScript!\`;
console.log(message);

// String methods
console.log("Upper case:", fullName.toUpperCase());
console.log("Lower case:", fullName.toLowerCase());
console.log("Length:", fullName.length);
console.log("First character:", fullName[0]);
console.log("Includes 'Kumar':", fullName.includes("Kumar"));

// String slicing
let text = "JavaScript Programming";
console.log("Substring:", text.substring(0, 10));
console.log("Slice:", text.slice(-11));

// Split and join
let words = text.split(" ");
console.log("Split words:", words);
console.log("Joined with dash:", words.join("-"));`
  },
  {
    title: "If-Else Statements",
    code: `// If-Else statements
let age = 20;

if (age >= 18) {
  console.log("You are an adult");
} else {
  console.log("You are a minor");
}

// Multiple conditions
let score = 85;
let grade;

if (score >= 90) {
  grade = "A";
} else if (score >= 80) {
  grade = "B";
} else if (score >= 70) {
  grade = "C";
} else {
  grade = "F";
}

console.log(\`Score: \${score}, Grade: \${grade}\`);

// Logical operators
let isWeekend = true;
let hasMoney = false;

if (isWeekend && hasMoney) {
  console.log("Let's go out!");
} else if (isWeekend || hasMoney) {
  console.log("Maybe we can do something");
} else {
  console.log("Stay home");
}

// Ternary operator
let isAdult = age >= 18 ? "Yes" : "No";
console.log(\`Is adult? \${isAdult}\`);`
  },
  {
    title: "Switch Statement",
    code: `// Switch statement
let day = "Monday";
let message;

switch (day) {
  case "Monday":
    message = "Start of the work week";
    break;
  case "Friday":
    message = "Weekend is almost here!";
    break;
  case "Saturday":
  case "Sunday":
    message = "It's the weekend!";
    break;
  default:
    message = "It's a regular day";
}

console.log(\`Today is \${day}: \${message}\`);

// Switch with numbers
let rating = 4;

switch (rating) {
  case 5:
    console.log("Excellent!");
    break;
  case 4:
    console.log("Very Good");
    break;
  case 3:
    console.log("Good");
    break;
  case 2:
    console.log("Needs Improvement");
    break;
  case 1:
    console.log("Poor");
    break;
  default:
    console.log("Invalid rating");
}`
  },
  {
    title: "For Loops",
    code: `// For loops
// Basic for loop
console.log("Numbers from 0 to 4:");
for (let i = 0; i < 5; i++) {
  console.log("Iteration:", i);
}

// Loop with different increment
console.log("Even numbers from 0 to 10:");
for (let i = 0; i <= 10; i += 2) {
  console.log(i);
}

// Looping through array
let fruits = ["apple", "banana", "cherry", "date"];
console.log("My favorite fruits:");
for (let i = 0; i < fruits.length; i++) {
  console.log(\`- \${fruits[i]}\`);
}

// For...of loop (ES6)
console.log("Using for...of loop:");
for (let fruit of fruits) {
  console.log(fruit);
}

// Looping through object keys
let person = { name: "Rajan", age: 25, city: "Delhi" };
console.log("Person properties:");
for (let key in person) {
  console.log(\`\${key}: \${person[key]}\`);
}`
  },
  {
    title: "While and Do-While Loops",
    code: `// While loops
// Basic while loop
let count = 1;
console.log("Counting to 5:");
while (count <= 5) {
  console.log("Count:", count);
  count++;
}

// Break and continue
console.log("Break and continue:");
let num = 0;
while (num < 10) {
  num++;
  if (num === 3) {
    continue; // Skip 3
  }
  if (num === 8) {
    break;    // Stop at 8
  }
  console.log(num);
}

// Do-while loop
let number;
console.log("Do-while example:");
do {
  number = Math.floor(Math.random() * 10);
  console.log("Generated number:", number);
} while (number !== 5);

console.log("Finally got 5!");`
  },
  {
    title: "Arrays and Array Methods",
    code: `// Arrays and array methods
// Creating arrays
let numbers = [1, 2, 3, 4, 5];
let fruits = ["apple", "banana", "cherry"];
let mixed = [1, "hello", true, null];

console.log("Original numbers:", numbers);
console.log("Original fruits:", fruits);

// Array methods
numbers.push(6);           // Add to end
console.log("After push:", numbers);

numbers.pop();             // Remove from end
console.log("After pop:", numbers);

numbers.unshift(0);        // Add to beginning
console.log("After unshift:", numbers);

numbers.shift();           // Remove from beginning
console.log("After shift:", numbers);

// Array transformation methods
let doubled = numbers.map(num => num * 2);
console.log("Doubled numbers:", doubled);

let evenNumbers = numbers.filter(num => num % 2 === 0);
console.log("Even numbers:", evenNumbers);

let sum = numbers.reduce((total, num) => total + num, 0);
console.log("Sum of numbers:", sum);

// Array searching
console.log("Index of 3:", numbers.indexOf(3));
console.log("Includes 5:", numbers.includes(5));

// Array slicing
console.log("First 3:", numbers.slice(0, 3));
console.log("Last 2:", numbers.slice(-2));

// Spread operator (ES6)
let newArray = [...numbers, 6, 7, 8];
console.log("New array with spread:", newArray);`
  },
  {
    title: "Objects and Object Methods",
    code: `// Objects and object methods
// Creating objects
let student = {
  name: "Rajan",
  age: 20,
  major: "Computer Science",
  gpa: 3.8,
  
  // Method
  introduce: function() {
    return \`Hello, I'm \${this.name} and I study \${this.major}\`;
  },
  
  // Shorthand method (ES6)
  getStatus() {
    return this.gpa >= 3.5 ? "Excellent" : "Good";
  }
};

console.log("Student object:", student);
console.log("Name:", student.name);
console.log("Age:", student["age"]);
console.log("Introduction:", student.introduce());
console.log("Status:", student.getStatus());

// Adding and modifying properties
student.year = "Junior";
student.age = 21;
console.log("Updated student:", student);

// Object methods
console.log("Keys:", Object.keys(student));
console.log("Values:", Object.values(student));
console.log("Entries:", Object.entries(student));

// Object destructuring (ES6)
let { name, age, major } = student;
console.log(\`Destructured: \${name}, \${age}, \${major}\`);

// Object spread (ES6)
let studentCopy = { ...student, graduationYear: 2024 };
console.log("Student copy:", studentCopy);`
  },
  {
    title: "Functions Basics",
    code: `// Functions in JavaScript
// Function declaration
function greet(name) {
  return \`Hello, \${name}!\`;
}

// Function expression
const add = function(a, b) {
  return a + b;
};

// Arrow function (ES6)
const multiply = (a, b) => a * b;

// Calling functions
console.log(greet("Rajan"));
console.log("5 + 3 =", add(5, 3));
console.log("4 * 6 =", multiply(4, 6));

// Function with default parameters
function introduce(name = "Guest", age = 25) {
  return \`Hi, I'm \${name} and I'm \${age} years old\`;
}

console.log(introduce());
console.log(introduce("Amit"));
console.log(introduce("Priya", 22));

// Rest parameters
function sum(...numbers) {
  return numbers.reduce((total, num) => total + num, 0);
}

console.log("Sum of 1,2,3,4,5:", sum(1, 2, 3, 4, 5));

// Higher-order function
function createMultiplier(multiplier) {
  return function(number) {
    return number * multiplier;
  };
}

const double = createMultiplier(2);
const triple = createMultiplier(3);

console.log("Double of 5:", double(5));
console.log("Triple of 5:", triple(5));`
  },
  {
    title: "Arrow Functions and Callbacks",
    code: `// Arrow functions and callbacks
// Different arrow function syntax
const square = x => x * x;
const greet = name => \`Hello, \${name}!\`;
const add = (a, b) => a + b;
const createPerson = (name, age) => ({ name, age });

console.log("Square of 4:", square(4));
console.log("Greeting:", greet("Rajan"));
console.log("Sum:", add(5, 3));
console.log("Person:", createPerson("Amit", 25));

// Callback functions
function processArray(arr, callback) {
  let result = [];
  for (let item of arr) {
    result.push(callback(item));
  }
  return result;
}

let numbers = [1, 2, 3, 4, 5];

// Using callbacks
let squared = processArray(numbers, x => x * x);
let doubled = processArray(numbers, x => x * 2);
let strings = processArray(numbers, x => \`Number: \${x}\`);

console.log("Squared:", squared);
console.log("Doubled:", doubled);
console.log("Strings:", strings);

// Array methods with callbacks
let evenNumbers = numbers.filter(num => num % 2 === 0);
let multiplied = numbers.map(num => num * 10);
let total = numbers.reduce((sum, num) => sum + num, 0);

console.log("Even numbers:", evenNumbers);
console.log("Multiplied by 10:", multiplied);
console.log("Total sum:", total);`
  },
  {
    title: "ES6+ Features",
    code: `// ES6+ Features
// Template literals
let name = "Rajan";
let age = 25;
console.log(\`My name is \${name} and I am \${age} years old\`);

// Destructuring
// Array destructuring
let numbers = [1, 2, 3, 4, 5];
let [first, second, ...rest] = numbers;
console.log("First:", first, "Second:", second, "Rest:", rest);

// Object destructuring
let person = { name: "Amit", age: 30, city: "Mumbai" };
let { name: personName, city } = person;
console.log("Name:", personName, "City:", city);

// Spread operator
let arr1 = [1, 2, 3];
let arr2 = [4, 5, 6];
let combined = [...arr1, ...arr2];
console.log("Combined array:", combined);

let obj1 = { a: 1, b: 2 };
let obj2 = { c: 3, d: 4 };
let merged = { ...obj1, ...obj2 };
console.log("Merged object:", merged);

// Rest parameters
function showSkills(name, ...skills) {
  console.log(\`\${name} has these skills: \${skills.join(", ")}\`);
}
showSkills("Rajan", "JavaScript", "React", "Node.js");`
  },
  {
    title: "Classes and OOP",
    code: `// Classes and Object-Oriented Programming
// Basic class
class Person {
  constructor(name, age) {
    this.name = name;
    this.age = age;
  }
  
  // Method
  introduce() {
    return \`Hello, I'm \${this.name} and I'm \${this.age} years old\`;
  }
  
  // Static method
  static species() {
    return "Homo sapiens";
  }
}

// Creating objects
let person1 = new Person("Rajan", 25);
let person2 = new Person("Amit", 30);

console.log(person1.introduce());
console.log(person2.introduce());
console.log("Species:", Person.species());

// Inheritance
class Student extends Person {
  constructor(name, age, major) {
    super(name, age); // Call parent constructor
    this.major = major;
  }
  
  // Method overriding
  introduce() {
    return \`\${super.introduce()} and I study \${this.major}\`;
  }
  
  // New method
  study() {
    return \`\${this.name} is studying \${this.major}\`;
  }
}

let student = new Student("Priya", 22, "Computer Science");
console.log(student.introduce());
console.log(student.study());`
  },
  {
    title: "Promises and Async/Await",
    code: `// Promises and Async/Await
// Creating a promise
function fetchData() {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const success = Math.random() > 0.3;
      if (success) {
        resolve("Data fetched successfully!");
      } else {
        reject("Failed to fetch data");
      }
    }, 2000);
  });
}

// Using promises
console.log("Fetching data...");
fetchData()
  .then(data => {
    console.log("Success:", data);
  })
  .catch(error => {
    console.log("Error:", error);
  })
  .finally(() => {
    console.log("Operation completed");
  });

// Async/await
async function processData() {
  try {
    console.log("Starting async operation...");
    let result = await fetchData();
    console.log("Async result:", result);
    return result;
  } catch (error) {
    console.log("Async error:", error);
    throw error;
  }
}

// Calling async function
processData().then(result => {
  console.log("Final result:", result);
});`
  },
  {
    title: "Error Handling",
    code: `// Error handling
// Basic try-catch
try {
  let result = 10 / 0;
  console.log("Result:", result);
  
  // Throwing custom error
  let age = -5;
  if (age < 0) {
    throw new Error("Age cannot be negative");
  }
} catch (error) {
  console.log("Error caught:", error.message);
} finally {
  console.log("This always executes");
}

// Custom error classes
class ValidationError extends Error {
  constructor(message) {
    super(message);
    this.name = "ValidationError";
  }
}

// Using custom errors
function validateUser(user) {
  if (!user.name) {
    throw new ValidationError("Name is required");
  }
  if (user.age < 0) {
    throw new ValidationError("Age cannot be negative");
  }
  return true;
}

// Error handling with async functions
async function processUser(userData) {
  try {
    validateUser(userData);
    console.log("User validated successfully");
    return "User processed successfully";
  } catch (error) {
    if (error instanceof ValidationError) {
      console.log("Validation error:", error.message);
    } else {
      console.log("Unknown error:", error.message);
    }
    throw error;
  }
}

// Testing error handling
processUser({ name: "Rajan", age: -5 })
  .then(result => console.log("Success:", result))
  .catch(error => console.log("Final error:", error.name));`
  }
];

export default jsLessons;